<script>
import { contentComputed } from '@state/helpers'
import appConfig from "@src/app.config.json"
import SiteFeatures from "@components/features/features.vue"

export default {
  page: {
    title: 'Servicios',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: { SiteFeatures },

  computed: {
    ...contentComputed
  }
}
</script>

<template>
  <div>
    <p>{{ info.services.intro }}</p>

    <div class="d-sm-none">
      <div class="text-center mt-4">
        <h2>{{ info.services.text }}</h2>
        <h4>{{ info.services.text2 }}</h4>
      </div>

      <SiteFeatures :list="info.services.list" />
    </div>

    <b-img-lazy class="m-2 d-none d-sm-block"
      center
      :src="info.services.image"
      fluid
      blank
      blank-color = "#E5E6E9"
      width = 1024
      height = 1200
      alt="services">
    </b-img-lazy>

    <div class="text-center mt-5">
      <h2>{{ info.services.title }}</h2>
      <h4>{{ info.services.subtitle }}</h4>
    </div>

    <SiteFeatures :list="info.services.benefits" />
  </div>
</template>

<style lang="scss" scoped>
</style>
